VLW.Compenents.IntersectionObjserver = class extends VLW.classBase {
	constructor(elt) {
		super(elt);
		this.interSectionObj = new IntersectionObserver(this.IntersectionObserverCallback, {threshold: this.threshold, rootMargin:this.rootMargin});
		this.interSectionObj.observe(this.elt);
	}
	
	get threshold(){
		return [0.1,0.2,0.3];
	}
	
	get rootMargin(){
		return "0px 0px 0px 0px";
	}
	
	IntersectionObserverCallback(elts) {
		elts.forEach(elt => {
			if (elt.intersectionRatio > 0) {
				this.interSectionObj.unobserve(this.elt);
				this.onIntersectionVisible();
			}
		});
	}
	
	onIntersectionVisible() {
		[...this.elt.querySelectorAll("[data-style-background]")].forEach((elt) => {
			const src = elt.dataset.styleBackground;
			(new Promise((resolve, reject) => {
				const image  = new Image();
				image.onload = resolve;
				image.src    = src;
			})).then(() => {
				elt.classList.add("_backgroundImageLoaded");
				elt.style.backgroundImage = `url(${src})`;
			});
		});
	}
	
	instanceClean() {
		this.interSectionObj.disconnect();
		super.instanceClean();
	}
};


